import { TableNodeProperties } from "@features/builder/graph/types"
import { NodeFormValues } from "@features/builder/NodeDrawer/NodeForm"
import NodeDrawerAccordion from "@features/builder/NodeDrawer/NodeDrawerAccordion"
import Add from "@mui/icons-material/Add"
import { Button, Grid } from "@mui/material"
import { ChangeEvent } from "react"
import { useFormContext } from "react-hook-form"
import {
  tableCsvToProperties,
  tablePropertiesToCsv,
} from "@features/builder/NodeDrawer/NodeForm/table.helpers"
import { downloadFile, readFile } from "@utils/file"
import TableNodeTable from "@features/builder/NodeDrawer/NodeForm/NodeTableAccordion/TableNodeTable"
import { enqueueSnackbar } from "notistack"

const NodeTableAccordion = (props: {
  onPropertiesUpdate: (properties: TableNodeProperties) => void
}) => {
  const form = useFormContext<NodeFormValues>()

  const handleAddColumn = () => {
    const updatedProperties = structuredClone(form.getValues("attributeProperties"))
    updatedProperties.columns.push(`col${updatedProperties.columns.length + 1}`)
    updatedProperties.data.map((row) => row.push("0"))
    props.onPropertiesUpdate(updatedProperties)
  }

  const handleAddRow = () => {
    const updatedProperties = structuredClone(form.getValues("attributeProperties"))

    const row = Array(updatedProperties.data[0]?.length).fill("0")
    updatedProperties.index.push(`row${updatedProperties.data.length + 1}`)
    updatedProperties.data.push(row)
    props.onPropertiesUpdate(updatedProperties)
  }
  const handleImport = async (e: ChangeEvent<HTMLInputElement>) => {
    if (!e.target.files?.[0]) return

    const fileAsString = await readFile(e.target.files[0])
    const propertiesFromFile = tableCsvToProperties(fileAsString)

    if (!propertiesFromFile) {
      enqueueSnackbar("Imported file does not contain any rows", { variant: "error" })
      return
    }

    const hasNonNumericCellValues = propertiesFromFile.data.some((rowData) =>
      rowData.some((value) => isNaN(Number(value))),
    )

    if (hasNonNumericCellValues) {
      enqueueSnackbar("Can not import file that contains non-numeric cell values", {
        variant: "error",
      })
      return
    }

    props.onPropertiesUpdate(propertiesFromFile)
  }

  const handleExport = () => {
    const table = tablePropertiesToCsv(form.getValues("attributeProperties"))
    const tableFileUrl = encodeURI(table)

    const fileName = `${form.getValues("label")}.csv`
    downloadFile(fileName, tableFileUrl)
  }

  return (
    <NodeDrawerAccordion id="table-atributes" label="Table Data">
      <Grid container item gap={1}>
        <Grid item>
          <Button
            variant="contained"
            startIcon={<Add />}
            onClick={handleAddRow}
            disabled={form.formState.disabled}
          >
            Add row
          </Button>
        </Grid>
        <Grid item>
          <Button
            variant="contained"
            startIcon={<Add />}
            onClick={handleAddColumn}
            disabled={form.formState.disabled}
          >
            Add column
          </Button>
        </Grid>
        <Grid item>
          <Button variant="contained" component="label" disabled={form.formState.disabled}>
            <input type="file" accept="text/csv" hidden value="" onChange={handleImport} />
            Import
          </Button>
        </Grid>
        <Grid item>
          <Button variant="contained" onClick={handleExport} disabled={form.formState.disabled}>
            Export
          </Button>
        </Grid>
      </Grid>
      <Grid item>
        <TableNodeTable onPropertiesUpdate={props.onPropertiesUpdate} />
      </Grid>
    </NodeDrawerAccordion>
  )
}

export default NodeTableAccordion
